import { render, staticRenderFns } from "./PurchasesOrderViewDetailsPurchasesOrderItemTableV2.vue?vue&type=template&id=f22de962"
import script from "./PurchasesOrderViewDetailsPurchasesOrderItemTableV2.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderViewDetailsPurchasesOrderItemTableV2.vue?vue&type=script&lang=js"
import style0 from "./PurchasesOrderViewDetailsPurchasesOrderItemTableV2.vue?vue&type=style&index=0&id=f22de962&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports